//get pay per view
export const GET_PAY_PER_VIEW = "GET_PAY_PER_VIEW";

//create pay per view
export const CREATE_NEW_PAY_PER_VIEW = "CREATE_NEW_PAY_PER_VIEW";

//edit pay per view
export const EDIT_PAY_PER_VIEW = "EDIT_PAY_PER_VIEW";

//delete pay per view
export const DELETE_PAY_PER_VIEW = "DELETE_PAY_PER_VIEW";

//dialog type
export const OPEN_PAY_PER_VIEW_DIALOG = "OPEN_PAY_PER_VIEW_DIALOG";
export const CLOSE_PAY_PER_VIEW_DIALOG = "CLOSE_PAY_PER_VIEW_DIALOG";
